import { cn } from "~/lib/cn";
import { AppLink } from "~/components/ui/AppLink";
import type { RouteKey } from "~/config/route-config";

type WordmarkProps = {
  className?: string;
  /** Runs on activation (the cúter closes itself; the auto-test may hold the navigation). */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  /** Accessible name of the link (omit for the inert span). */
  "aria-label"?: string;
} & (
  | { routeKey: RouteKey; search?: string; to?: never; inert?: never }
  | { to: string; routeKey?: never; inert?: never }
  | { inert: true; routeKey?: never; to?: never }
);

/** The three syllables with the brand gradient on «Fitt» — one source for the mark. */
function WordmarkText() {
  return (
    <>
      The<span className="fitt text-gradient-tfc">Fitt</span>Club
    </>
  );
}

/**
 * T872 S1 — the wordmark as one component. Until now the same three-span markup was
 * typed by hand in the two headers, the cúter and the footer; a change to the mark
 * (or to R-T226-1's gradient class) had four places to miss. `inert` renders a
 * `<span>` for surfaces where the mark is not a link (the open cúter's bar).
 */
export function Wordmark(props: WordmarkProps) {
  const className = cn("wordmark", props.className);
  const label = props["aria-label"];
  if (props.inert) {
    return (
      <span className={className}>
        <WordmarkText />
      </span>
    );
  }
  if (props.routeKey) {
    return (
      <AppLink routeKey={props.routeKey} search={props.search} className={className} aria-label={label} onClick={props.onClick}>
        <WordmarkText />
      </AppLink>
    );
  }
  return (
    <AppLink to={props.to} className={className} aria-label={label} onClick={props.onClick}>
      <WordmarkText />
    </AppLink>
  );
}
